
export class Model_CRM_CallType {
    public CallTypeId: number;
    public Calldescription: string;
}